// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import KeyOutlinedSvg from "@ant-design/icons-svg/es/asn/KeyOutlined";
import AntdIcon from '../components/AntdIcon';

var KeyOutlined = function KeyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: KeyOutlinedSvg
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
export default React.forwardRef(KeyOutlined);